'use client';

import { c as _c } from "react/compiler-runtime";
import avatarIcon from '@public/images/avatar.svg';
import Image from 'next/image';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV4/TopNavContext';
import { useSession } from '@src/hooks/useSession';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
export const TopNavMobileBar = () => {
  const $ = _c(26);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    t
  } = useLocale("common");
  const {
    user
  } = useSession();
  const {
    isMobileSubExpanded,
    logo,
    isExpanded,
    setExpanded,
    setExpandedMenu,
    setMobileSubExpanded,
    setAccountExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== isExpanded || $[1] !== isMobileSubExpanded || $[2] !== setExpanded || $[3] !== setExpandedMenu || $[4] !== setMobileSubExpanded) {
    t0 = () => <button data-testid="topNavMobileMenu" onClick={() => {
      if (!isExpanded || !isMobileSubExpanded) {
        setExpandedMenu(null);
        setMobileSubExpanded(false);
      }
      setExpanded(!isExpanded);
    }} className={"flex size-6 appearance-none flex-col items-center justify-center\n          *:h-0.5 *:w-6 *:rounded-sm *:bg-white *:transition-all"}><div className="-translate-y-1" /><div /><div className="translate-y-1" /></button>;
    $[0] = isExpanded;
    $[1] = isMobileSubExpanded;
    $[2] = setExpanded;
    $[3] = setExpandedMenu;
    $[4] = setMobileSubExpanded;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const renderHamburger = t0;
  let t1;
  if ($[6] !== renderHamburger) {
    t1 = <div className="flex items-center">{renderHamburger()}</div>;
    $[6] = renderHamburger;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== logo || $[9] !== trackSelectNavCta) {
    t2 = logo?.src && <LocalizedLink onClick={() => {
      trackSelectNavCta({
        "cta url": logo?.href
      });
    }} href={logo?.href ?? ""}><Image src={logo.src} width={logo?.mobileWidth} height={logo?.mobileHeight} alt={logo?.altText ?? ""} /></LocalizedLink>;
    $[8] = logo;
    $[9] = trackSelectNavCta;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <div className="flex gap-6">{t1}{t2}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== setAccountExpanded) {
    t4 = () => {
      setAccountExpanded(true);
    };
    $[14] = setAccountExpanded;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src={avatarIcon} width={24} height={24} alt="Account icon" />;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t || $[18] !== user) {
    t6 = user ? t("my-account") : t("login-join");
    $[17] = t;
    $[18] = user;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t6) {
    t7 = <div className="flex gap-3"><button onClick={t4} data-testid="bodiBtn" className="flex items-center gap-2 font-medium text-bodi-gray-butters">{t5}{t6}</button></div>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t3 || $[24] !== t7) {
    t8 = <Container className="h-full *:h-full"><div className="flex h-full flex-row items-center justify-between">{t3}{t7}</div></Container>;
    $[23] = t3;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};